<template>
  <div id="app">
    <main id="main">
      <transition mode="out-in">
        <router-view />
      </transition>
    </main>
    <webnar-footer />
  </div>
</template>

<script>
import webnarFooter from "@/components/general/webnarFooter.vue";
export default {
  components: {
    webnarFooter,
  },
};
</script>

<style lang="scss">
#app {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: all 1s ease;
}

#main {
  flex: 1;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter {
  transform: translate3d(0, -20px, 0);
}

.v-leave-to {
  transform: translate3d(0, 20px, 0);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.p-relative {
  position: relative;
}

.h-100 {
  height: 100%;
}
</style>
